"use client";

import { useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
gsap.registerPlugin(useGSAP, ScrollTrigger);
const projects = [{
  ordinal: "01",
  eyebrow: "Indústria Alimentar.",
  title: "Sistemas de Higienização.",
  outcome: "Implementação de sistemas de lavagem automática de tanques, garantindo conformidade rigorosa com normas de segurança alimentar.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/food_industry_cleaning.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/food_industry_cleaning.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/food_industry_cleaning.webp-wvc-sizes",
  alt: "Sistema de lavagem de tanques em aço inoxidável na indústria alimentar",
  href: "/FoodAndBeverageSuccessCasePage"
}, {
  ordinal: "02",
  eyebrow: "Setor Automóvel.",
  title: "Linhas de Pintura.",
  outcome: "Otimização de bicos de pulverização para linhas de pintura, reduzindo o desperdício de tinta e melhorando o acabamento final.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/automotive_painting.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/automotive_painting.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/automotive_painting.png-wvc-sizes",
  alt: "Braço robótico de pintura industrial em ambiente fabril",
  href: "/AutomotiveManufacturingSuccessCasePage"
}, {
  ordinal: "03",
  eyebrow: "Processamento Químico.",
  title: "Controlo de Reações.",
  outcome: "Soluções de atomização de alta precisão para reatores químicos, assegurando a homogeneidade e eficiência dos processos.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/chemical_processing.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/chemical_processing.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1738660/img/chemical_processing.png-wvc-sizes",
  alt: "Equipamento de processamento químico com sistemas de pulverização",
  href: "/ChemicalProcessingSuccessCasePage"
}];
export default function Casestudyshowcase() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".sw-header-eyebrow", {
        y: 16
      });
      gsap.set(".sw-header-title", {
        y: 24
      });
      gsap.to(".sw-header-eyebrow", {
        opacity: 1,
        y: 0,
        duration: 0.7,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 85%",
          once: true
        }
      });
      gsap.to(".sw-header-title", {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power3.out",
        delay: 0.1,
        scrollTrigger: {
          trigger: el,
          start: "top 85%",
          once: true
        }
      });
      const rows = gsap.utils.toArray<HTMLElement>(".sw-row");
      rows.forEach(row => {
        const numeral = row.querySelector(".sw-numeral");
        const media = row.querySelector<HTMLElement>(".sw-media-img");
        const textEls = row.querySelectorAll(".sw-text > *");
        if (numeral) {
          gsap.to(numeral, {
            opacity: 0.6,
            duration: 0.6,
            ease: "power2.out",
            scrollTrigger: {
              trigger: row,
              start: "top 80%",
              once: true
            }
          });
        }
        if (media) {
          gsap.set(media, {
            scale: 1.02
          });
          gsap.to(media, {
            scale: 1,
            duration: 0.9,
            ease: "power2.out",
            scrollTrigger: {
              trigger: row,
              start: "top 80%",
              once: true
            }
          });
        }
        if (textEls.length) {
          gsap.set(textEls, {
            y: 20
          });
          gsap.to(textEls, {
            opacity: 1,
            y: 0,
            duration: 0.7,
            stagger: 0.08,
            ease: "power3.out",
            scrollTrigger: {
              trigger: row,
              start: "top 78%",
              once: true
            }
          });
        }
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".sw-header-eyebrow", ".sw-header-title", ".sw-text > *"], {
        opacity: 1,
        y: 0
      });
      gsap.set(".sw-numeral", {
        opacity: 0.6
      });
      gsap.set(".sw-media-img", {
        scale: 1
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section ref={container} className="relative overflow-hidden bg-background text-foreground py-20 md:py-28 lg:py-32">
      <div className="mx-auto max-w-[1360px] px-4 sm:px-6 lg:px-8">
        <div className="mx-auto mb-16 md:mb-24 max-w-2xl text-center space-y-3">
          <div className="sw-header-eyebrow text-xs sm:text-sm font-semibold uppercase tracking-wider text-secondary" style={{
          opacity: 0
        }}>
            Outros Casos de Sucesso
          </div>
          <h2 className="sw-header-title text-3xl sm:text-4xl md:text-5xl font-semibold tracking-tight text-foreground" style={{
          opacity: 0
        }}>
            Descubra Como Ajudamos Outras Indústrias
          </h2>
        </div>

        <div className="flex flex-col gap-16 md:gap-24">
          {projects.map((p, i) => <div key={p.ordinal} data-index={i} className="sw-row grid md:grid-cols-12 gap-8 items-center">
              <span className="sw-numeral text-4xl sm:text-5xl md:text-6xl font-mono font-light text-muted-foreground/60 md:col-span-1 select-none" style={{
            opacity: 0.6
          }}>
                {p.ordinal}
              </span>

              <div className="md:col-span-6 overflow-hidden rounded-xl border border-border/50 bg-card shadow-sm">
                <img src={p.image} data-wvc-srcset={p.srcset} data-wvc-sizes={p.sizes} alt={p.alt} loading="lazy" className="sw-media-img w-full h-auto object-cover aspect-video md:aspect-[16/10]" style={{
              transform: "scale(1.02)"
            }} />
              </div>

              <div className="sw-text md:col-span-5 flex flex-col items-start gap-4">
                <span className="text-xs font-semibold uppercase tracking-wider text-secondary" style={{
              opacity: 0
            }}>
                  {p.eyebrow}
                </span>
                <h3 className="text-2xl sm:text-3xl font-semibold tracking-tight text-foreground" style={{
              opacity: 0
            }}>
                  {p.title}
                </h3>
                <p className="text-sm sm:text-base text-muted-foreground leading-relaxed" style={{
              opacity: 0
            }}>
                  {p.outcome}
                </p>
                <Button asChild variant="outline" className="gap-2 rounded-lg mt-2" style={{
              opacity: 0
            }}>
                  <Link to={p.href}>
                    <span>Ver Caso de Estudo</span>
                    <ArrowUpRight className="size-4" />
                  </Link>
                </Button>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}